import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { SubscriptionDetails } from 'organization/types'

const useGetSubscriptionDetails = (): [
  (id: number) => Promise<SubscriptionDetails | null>,
  Status<SubscriptionDetails>,
] => {
  const [request, status] = useFetchRefactored<SubscriptionDetails>()

  const getSubscriptionDetails = useCallback(
    async (organizationId: number) => {
      try {
        // `await` required for catch() to fire
        return await request({
          method: 'get',
          url: `/organizations/${organizationId}/subscription_details`,
        })
      } catch (error) {
        // @ts-ignore
        if (error.response?.status === 404) {
          return null
        }

        throw error
      }
    },
    [request],
  )

  return [getSubscriptionDetails, status]
}

export default useGetSubscriptionDetails
